import styled from 'styled-components';

export const StyledDiv = styled.div`
  border-bottom: 5px solid #B7E7FF !important;
  background:white;
`;
